import type { DayTradingSessionState } from '@/models/day-trading-session';

export function detectSessionStateChange(
  prev: DayTradingSessionState,
  next: DayTradingSessionState,
): 'new' | 'change' | null {
  let hasNew = false;
  let hasChange = false;

  const prevTradeMap = new Map(prev.trades.map((t) => [t.id, t]));

  for (const nextTrade of next.trades) {
    const prevTrade = prevTradeMap.get(nextTrade.id);

    if (prevTrade === undefined) {
      hasNew = true;
      continue;
    }

    // Check for new adjustments
    const prevAdjIds = new Set(prevTrade.adjustments.map((a) => a.id));
    for (const adj of nextTrade.adjustments) {
      if (!prevAdjIds.has(adj.id)) {
        hasNew = true;
      }
    }

    // Check trade state change
    if (prevTrade.state !== nextTrade.state) {
      hasChange = true;
    }

    // Check trade field changes
    if (
      prevTrade.targetPrice !== nextTrade.targetPrice ||
      prevTrade.share !== nextTrade.share ||
      prevTrade.type !== nextTrade.type ||
      prevTrade.symbol !== nextTrade.symbol
    ) {
      hasChange = true;
    }

    // Check adjustment entryPrice changes
    const prevAdjMap = new Map(prevTrade.adjustments.map((a) => [a.id, a]));
    for (const adj of nextTrade.adjustments) {
      const prevAdj = prevAdjMap.get(adj.id);
      if (prevAdj !== undefined && prevAdj.entryPrice !== adj.entryPrice) {
        hasChange = true;
      }
    }
  }

  if (hasNew) return 'new';
  if (hasChange) return 'change';
  return null;
}
